<template>
  <div class="page page--profile">
    <div class="page__header">
      <router-link to="/cabinet" class="page__back-link">
        <arrow-button
          class="page__back-link-icon"
          :rotated180="true"
        ></arrow-button>
      </router-link>
      <div class="page__title">
        <template v-if="isMobile">
          {{ $t('user-profile.title.personal-data') }}
        </template>
        <template v-else>
          {{ $t('user-profile.title.profile-settings') }}
        </template>
      </div>
    </div>
    <div class="user-form">
      <div class="user-form__loader" v-if="isProfileSaving">
        <loader></loader>
      </div>
      <div class="user-form__title" v-if="!isMobile">
        {{ $t('user-profile.title.personal-data') }}
      </div>
      <div class="user-form__fields">
        <div class="user-form__field">
          <text-input
            :title="$t('user-profile.fields.firstname.title')"
            name="name"
            v-model:value="user.FirstName"
          ></text-input>
        </div>
        <div class="user-form__field">
          <text-input
            :title="$t('user-profile.fields.surname.title')"
            name="surname"
            v-model:value="user.LastName"
          ></text-input>
        </div>
        <div class="user-form__field">
          <text-input
            :title="$t('user-profile.fields.email.title')"
            name="email"
            v-model:value="user.Email"
            :disabled="true"
            :with-information="true"
          >
            <template #information>
              <change-phone-email-hint></change-phone-email-hint>
            </template>
          </text-input>
        </div>
        <div class="user-form__field">
          <text-input
            :title="$t('user-profile.fields.phone.title')"
            name="phone"
            v-model:value="user.Phone"
            :disabled="true"
            :with-information="true"
          >
            <template #information>
              <change-phone-email-hint></change-phone-email-hint>
            </template>
          </text-input>
        </div>
        <div class="user-form__field">
          <text-input
            type="password"
            :disabled="true"
            :title="$t('user-profile.fields.password.title')"
            v-model:value="password"
            name="password"
            placeholder="********"
          ></text-input>
        </div>
      </div>
      <div class="user-form__change-password" @click="changePassword">
        <div class="user-form__change-password-button">
          {{ $t('user-profile.actions.change-password') }}
        </div>
      </div>
      <div class="user-form__tfa">
        <switcher
          :label="$t('user-profile.fields.tfa.title')"
          v-model:checked="isTfaEnabled"
          @update="handleTFAClick"
        ></switcher>
        <div class="user-form__tfa-hint">
          {{ $t('user-profile.fields.tfa.hint') }}
        </div>
      </div>
      <div class="user-form__save">
        <primary-button
          class="primary-button"
          @click="saveProfile"
          :label="$t('user-profile.actions.save')"
        ></primary-button>
      </div>
    </div>
    <success-notification
      :text="$t('user-profile.notifications.profile-saved-success')"
      ref="profileSavedSuccessNotification"
    ></success-notification>
  </div>
</template>

<script>
import CompanyCard from '@vue-app/components/company/card/CompanyCard.vue'
import { UserApi } from '@js-app/office/api/user-api'
import ArrowButton from '@vue-app/components/base/button/ArrowButton.vue'
import TextInput from '@vue-app/components/base/input/TextInput.vue'
import Switcher from '@vue-app/components/base/input/Switcher.vue'
import responsiveMixin from '@vue-app/mixins/responsive-mixin'
import SuccessNotification from '@vue-app/components/base/popup/notification/SuccessNotification.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import {
  LOAD_USER_DATA,
  UPDATE_USER_DATA,
} from '@vue-app/store/const/actions-types'
import { mapGetters } from 'vuex'
import Loader from '@vue-app/components/base/Loader.vue'
import ChangePhoneEmailHint from '@vue-app/components/user/profile/ChangePhoneEmailHint.vue'

export default {
  name: 'Profile',
  components: {
    ChangePhoneEmailHint,
    Loader,
    PrimaryButton,
    SuccessNotification,
    Switcher,
    TextInput,
    ArrowButton,
    CompanyCard,
  },
  mixins: [responsiveMixin],
  data() {
    return {
      user: {},
      isTfaEnabled: true,
      password: '',
      isProfileSaving: false,
    }
  },
  async created() {
    await this.$store.dispatch(LOAD_USER_DATA)

    if (this.user.OptionalParams.NoNeed2F !== undefined) {
      this.isTfaEnabled = !this.user.OptionalParams.NoNeed2F
    } else {
      this.isTfaEnabled = true
    }
  },
  computed: {
    ...mapGetters(['userData']),
  },
  watch: {
    userData() {
      this.user = { ...this.userData }
    },
  },

  methods: {
    async handleTFAClick(isChecked) {
      this.isTfaEnabled = isChecked
    },
    async saveProfile() {
      this.isProfileSaving = true

      await UserApi.updateUser({
        FirstName: this.user.FirstName,
        LastName: this.user.LastName,
        OptionalParams: {
          NoNeed2F: !this.isTfaEnabled,
        },
      })

      this.$store.commit(UPDATE_USER_DATA, this.user)

      this.isProfileSaving = false
      this.$refs.profileSavedSuccessNotification.show()
    },
    async changePassword() {
      this.$router.push('/cabinet/profile/change-password')
      // await UserApi.updatePassword(this.user.UserID, this.password);
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  &--profile {
    padding-bottom: 50px;
    margin-top: 60px;
  }

  &__header {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
  }

  &__back-link {
    margin-right: 18px;
  }

  &__title {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #585f6d;
  }
}
.user-form {
  padding: 34px 50px;
  background: #ffffff;
  border-radius: 22px;
  max-width: 390px;
  position: relative;
  &__loader {
    position: absolute;
    border-radius: 22px;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(#ffffff, 0.7);
    z-index: 99;
  }

  &__title {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #67768a;
    margin-bottom: 40px;
  }

  &__field {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__change-password {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 20px;

    &-button {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #64748B;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  &__tfa {
    margin-top: 40px;

    &-hint {
      font-weight: 500;
      font-size: 10px;
      line-height: 14px;
      color: #b9c4d8;
      margin-top: 8px;
    }
  }

  &__save {
    margin-top: 60px;
    width: calc(100% - 40px);
    margin-left: auto;
    margin-right: auto;
  }
}
.primary-button {
  width: 100%;
  padding: 25px;
  background: #64748B;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
@media screen and (max-width: 992px) {
  .page {
    &--profile {
      margin-top: 20px;
    }

    &__title {
      font-weight: 700;
      font-size: 18px;
      line-height: 26px;
      /* identical to box height, or 144% */

      /* text 1 */

      color: #47475e;
    }
  }
}
</style>
